module.exports = __webpack_public_path__ + "img/logo5.2f745936.svg";